const uint8ArrayToBase64 = (uint8Array: Uint8Array): string => {
  const CHUNK_SIZE = 0x8000;
  let base64 = '';
  for (let i = 0; i < uint8Array.length; i += CHUNK_SIZE) {
    const chunk = uint8Array.subarray(i, i + CHUNK_SIZE);
    base64 += String.fromCharCode.apply(null, chunk as any);
  }
  return btoa(base64); 
};

export const dataToBase64 = async (f: File): Promise<string> => {
  try {
    const arrayBuffer = await f.arrayBuffer();
    const uint8Array = new Uint8Array(arrayBuffer);
    
    const base64String = uint8ArrayToBase64(uint8Array);
    
    return base64String;
  } catch (error) {
    console.error('Error converting file to base64:', error);
    throw new Error('Failed to convert file to base64');
  }
};

export const dataToBase642 = async (f: File): Promise<{ base64: string; error: Error | null }> => {
  return new Promise((resolve) => {
    if (f.size > 900_000_000) {
      resolve({ base64: '', error: new Error('File size exceeds 900 MB') });
      return;
    }

    const reader = new FileReader();
    
    reader.onload = () => {
      try {
        const result = reader.result as string;
        const base64 = result.split(',')[1];
        resolve({ base64, error: null });
      } catch (error) {
        resolve({ base64: '', error: error instanceof Error ? error : new Error('Unknown error') });
      }
    };
    
    reader.onerror = () => {
      resolve({ base64: '', error: new Error('Error reading file') });
    };
    
    reader.readAsDataURL(f);
  });
};

export const dataToBase643 = (f: File): Promise<{ base64: string; error: Error | null }> => {
  return new Promise((resolve) => {
    if (f.size > 900_000_000) {
      resolve({ base64: '', error: new Error('File size exceeds 900 MB') });
      return;
    }

    const reader = new FileReader();
    
    reader.onload = () => {
      try {
        // Remover el prefijo "data:*/*;base64,"
        const result = reader.result as string;
        const base64 = result.substring(result.indexOf(',') + 1);
        resolve({ base64, error: null });
      } catch (error) {
        resolve({ base64: '', error: error instanceof Error ? error : new Error('Unknown error') });
      }
    };
    
    reader.onerror = () => {
      resolve({ base64: '', error: new Error('Error reading file') });
    };
    
    reader.readAsDataURL(f);
  });
};


export function downloadFile(name: string, mimeType: string, data: string) {
  const f = atob(data)
  const length = f.length
  const ab = new ArrayBuffer(length)
  const ua = new Uint8Array(ab)
  for (let i = 0; i < length; i++) {
    ua[i] = f.charCodeAt(i)
  }
  const blob = new Blob([ab], { type: mimeType })

  //@ts-ignore
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    //@ts-ignorez
    window.navigator.msSaveOrOpenBlob(blob, name)
    return
  } else {
    console.log("La propiedad navigator.msSaveOrOpenBlob no está disponible.");
  }
  const blobURL = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = blobURL
  link.download = name
  link.setAttribute('download', name)

  if (!link.download) {
    link.setAttribute('target', '_blank')
  }
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  setTimeout(() => {
    window.URL.revokeObjectURL(blobURL)
  }, 100)
}

